<script setup lang="ts">
import DeleteButton from "@/components/DeleteButton.vue";
import HandleQueryStatus from "@/components/HandleQueryStatus.vue";
import EditLink from "@/components/links/EditLink.vue";
import ManagementLayout from "@/layouts/ManagementLayout.vue";
import { Plus, Trash } from "@iconoir/vue";
import { RouterLink } from "vue-router";
import { useDeleteArea, useGetAreas } from "./areasCrud";

const { areas, getAreasStatus } = useGetAreas();
const { deleteArea, resetDeleteArea, deleteAreaStatus } = useDeleteArea();
</script>

<template>
  <ManagementLayout>
    <template #header>
      <h1>Gebiete</h1>
      <RouterLink :to="{ name: 'newArea' }" class="button" role="button">
        <Plus /> Gebiet anlegen
      </RouterLink>
    </template>
    <HandleQueryStatus :query-status="getAreasStatus">
      <table>
        <thead>
          <tr>
            <th>Name</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="area in areas" :key="area.id">
            <td>
              <RouterLink
                :to="{
                  name: 'editArea',
                  params: { id: area.id },
                }"
                class="column--primary-action"
              >
                {{ area.name }}
              </RouterLink>
            </td>
            <td class="actions">
              <EditLink :to="{ name: 'editArea', params: { id: area.id } }" />
              <DeleteButton
                class="button button--tertiary"
                :deleting-status="deleteAreaStatus"
                :disabled="area.canvassIds.length > 0"
                disabled-reason="Gebiet wird bereits in einer Haustüraktion verwendet."
                @initiated="resetDeleteArea()"
                @confirmed="deleteArea(area)"
              >
                <Trash />
                <span class="visually-hidden"> Löschen </span>
                <template #confirmation>
                  Möchtest du das Gebiet "{{ area.name }}" wirklich löschen?
                </template>
              </DeleteButton>
            </td>
          </tr>
        </tbody>
      </table>
    </HandleQueryStatus>
  </ManagementLayout>
</template>
